var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 37,
    viewBox: "0 0 140 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.992 37H5.15354C2.32038 37 0 34.9172 0 32.3741V4.61905C0 2.07599 2.32038 -0.00680256 5.15354 -0.00680256H133.992C136.825 -0.00680256 139.146 2.07599 139.146 4.61905V32.3741C139.146 34.9172 136.825 37 133.992 37Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.992 0.734488C136.378 0.734488 138.32 2.47728 138.32 4.61905V32.3741C138.32 34.5159 136.378 36.2587 133.992 36.2587H5.15354C2.76745 36.2587 0.825854 34.5159 0.825854 32.3741V4.61905C0.825854 2.47728 2.76745 0.734488 5.15354 0.734488H133.992ZM133.992 -0.00680256H5.15354C2.32038 -0.00680256 0 2.07599 0 4.61905V32.3741C0 34.9172 2.32038 37 5.15354 37H133.992C136.825 37 139.146 34.9172 139.146 32.3741V4.61905C139.146 2.07599 136.825 -0.00680256 133.992 -0.00680256Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7548 6.96839C10.4521 7.25288 10.2769 7.6958 10.2769 8.26941V28.7295C10.2769 29.3032 10.4521 29.7461 10.7548 30.0306L10.8296 30.093L23.6026 18.6325V18.3619L10.8296 6.90132L10.7548 6.96839Z",
    fill: "url(#paint0_linear_4686_96277)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8567 22.4553L23.6038 18.6332V18.3626L27.8619 14.5405L27.9572 14.5902L32.9999 17.1657C34.4391 17.8965 34.4391 19.0993 32.9999 19.8348L27.9572 22.4056L27.8567 22.4553Z",
    fill: "url(#paint1_linear_4686_96277)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9581 22.405L23.6046 18.4973L10.7568 30.0307C11.2348 30.4817 12.0143 30.536 12.9007 30.085L27.9581 22.405Z",
    fill: "url(#paint2_linear_4686_96277)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9581 14.5889L12.9007 6.90883C12.0143 6.46244 11.2348 6.51679 10.7568 6.96781L23.6046 18.4966L27.9581 14.5889Z",
    fill: "url(#paint3_linear_4686_96277)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8731 9.47101C48.8731 10.2435 48.6154 10.8622 48.1078 11.3237C47.5241 11.8707 46.764 12.1459 45.8325 12.1459C44.9422 12.1459 44.1821 11.866 43.5585 11.3144C42.9336 10.7547 42.6218 10.0677 42.6218 9.2455C42.6218 8.42326 42.9336 7.73632 43.5585 7.18122C44.1821 6.62496 44.9422 6.34509 45.8325 6.34509C46.2757 6.34509 46.6983 6.4272 47.1015 6.57985C47.5035 6.73366 47.8308 6.94183 48.0678 7.19856L47.5293 7.68659C47.1157 7.24829 46.5527 7.03203 45.8325 7.03203C45.1831 7.03203 44.6201 7.23557 44.1421 7.64611C43.6693 8.05781 43.4322 8.59094 43.4322 9.2455C43.4322 9.90006 43.6693 10.4378 44.1421 10.8495C44.6201 11.2554 45.1831 11.4636 45.8325 11.4636C46.5218 11.4636 47.1015 11.2554 47.5589 10.8449C47.8604 10.5731 48.0318 10.1984 48.0768 9.71965H45.8325V9.05122H48.8267C48.8628 9.19577 48.8731 9.3357 48.8731 9.47101Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6232 7.15271H50.8106V8.91054H53.3462V9.57897H50.8106V11.3368H53.6232V12.018H50.0144V6.47156H53.6232V7.15271Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9752 12.018H56.179V7.15271H54.4539V6.47156H58.7017V7.15271H56.9752V12.018Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7771 12.018V6.47156H62.572V12.018H61.7771Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0953 12.018H65.3056V7.15271H63.574V6.47156H67.8269V7.15271H66.0953V12.018Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8664 11.3052C75.257 11.866 74.502 12.1459 73.6014 12.1459C72.6957 12.1459 71.9407 11.866 71.3313 11.3052C70.7232 10.7454 70.4204 10.0585 70.4204 9.2455C70.4204 8.43251 70.7232 7.74557 71.3313 7.18584C71.9407 6.62496 72.6957 6.34509 73.6014 6.34509C74.4969 6.34509 75.2519 6.62496 75.8613 7.19047C76.4745 7.75482 76.7773 8.43713 76.7773 9.2455C76.7773 10.0585 76.4745 10.7454 75.8664 11.3052ZM71.9201 10.8403C72.3788 11.2554 72.9366 11.4636 73.6014 11.4636C74.2611 11.4636 74.8241 11.2554 75.2776 10.8403C75.735 10.4251 75.9669 9.89196 75.9669 9.2455C75.9669 8.59904 75.735 8.06591 75.2776 7.65074C74.8241 7.23557 74.2611 7.02741 73.6014 7.02741C72.9366 7.02741 72.3788 7.23557 71.9201 7.65074C71.4627 8.06591 71.2308 8.59904 71.2308 9.2455C71.2308 9.89196 71.4627 10.4251 71.9201 10.8403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8953 12.018V6.47156H78.8616L81.8661 10.7852H81.9008L81.8661 9.7189V6.47156H82.661V12.018H81.8313L78.685 7.49156H78.6503L78.685 8.56244V12.018H77.8953Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0424786,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2276 20.1178C67.8067 20.1178 65.829 21.7715 65.829 24.0532C65.829 26.3164 67.8067 27.9875 70.2276 27.9875C72.6536 27.9875 74.6313 26.3164 74.6313 24.0532C74.6313 21.7715 72.6536 20.1178 70.2276 20.1178ZM70.2276 26.4379C68.8992 26.4379 67.7564 25.4537 67.7564 24.0532C67.7564 22.6343 68.8992 21.6674 70.2276 21.6674C71.5559 21.6674 72.7038 22.6343 72.7038 24.0532C72.7038 25.4537 71.5559 26.4379 70.2276 26.4379ZM60.6304 20.1178C58.2044 20.1178 56.2318 21.7715 56.2318 24.0532C56.2318 26.3164 58.2044 27.9875 60.6304 27.9875C63.0551 27.9875 65.0289 26.3164 65.0289 24.0532C65.0289 21.7715 63.0551 20.1178 60.6304 20.1178ZM60.6304 26.4379C59.3008 26.4379 58.1541 25.4537 58.1541 24.0532C58.1541 22.6343 59.3008 21.6674 60.6304 21.6674C61.9587 21.6674 63.1015 22.6343 63.1015 24.0532C63.1015 25.4537 61.9587 26.4379 60.6304 26.4379ZM49.2101 21.324V22.9962H53.6589C53.5288 23.9306 53.1809 24.6176 52.6476 25.0964C51.9982 25.6746 50.9868 26.3164 49.2101 26.3164C46.4723 26.3164 44.3285 24.3331 44.3285 21.8756C44.3285 19.4181 46.4723 17.4348 49.2101 17.4348C50.6905 17.4348 51.7676 17.954 52.5625 18.6271L53.8754 17.4487C52.7635 16.4957 51.2844 15.7637 49.2101 15.7637C45.4558 15.7637 42.3005 18.5057 42.3005 21.8756C42.3005 25.2455 45.4558 27.9875 49.2101 27.9875C51.2393 27.9875 52.7635 27.3908 53.9617 26.2713C55.1895 25.1692 55.5722 23.6196 55.5722 22.3683C55.5722 21.9797 55.5361 21.6223 55.4717 21.324H49.2101ZM95.9089 22.6204C95.5469 21.7403 94.4299 20.1178 92.1546 20.1178C89.8999 20.1178 88.0227 21.7126 88.0227 24.0532C88.0227 26.2574 89.8806 27.9875 92.371 27.9875C94.3848 27.9875 95.5469 26.8854 96.0249 26.2436L94.5304 25.3496C94.0318 26.0042 93.3528 26.4379 92.371 26.4379C91.3957 26.4379 90.6961 26.0366 90.2478 25.2455L96.1112 23.0679L95.9089 22.6204ZM89.9308 23.9306C89.8806 22.4134 91.2437 21.6362 92.2203 21.6362C92.9856 21.6362 93.6349 21.9797 93.8514 22.4712L89.9308 23.9306ZM85.1651 27.7481H87.0925V16.1835H85.1651V27.7481ZM82.0086 20.9944H81.9441C81.5112 20.5341 80.6854 20.1178 79.6392 20.1178C77.4438 20.1178 75.4365 21.8479 75.4365 24.066C75.4365 26.2713 77.4438 27.9875 79.6392 27.9875C80.6854 27.9875 81.5112 27.5677 81.9441 27.0936H82.0086V27.6579C82.0086 29.1625 81.1131 29.9708 79.6688 29.9708C78.4913 29.9708 77.7607 29.2076 77.4593 28.5657L75.7831 29.1937C76.2662 30.2368 77.5456 31.5205 79.6688 31.5205C81.9287 31.5205 83.8355 30.327 83.8355 27.4232V20.3572H82.0086V20.9944ZM79.8041 26.4379C78.4758 26.4379 77.3639 25.4398 77.3639 24.066C77.3639 22.6794 78.4758 21.6674 79.8041 21.6674C81.1131 21.6674 82.1451 22.6794 82.1451 24.066C82.1451 25.4398 81.1131 26.4379 79.8041 26.4379ZM104.933 16.1835H100.323V27.7481H102.245V23.3663H104.933C107.068 23.3663 109.161 21.9797 109.161 19.7743C109.161 17.5701 107.062 16.1835 104.933 16.1835ZM104.983 21.7577H102.245V17.7921H104.983C106.418 17.7921 107.238 18.8619 107.238 19.7743C107.238 20.6694 106.418 21.7577 104.983 21.7577ZM116.866 20.0958C115.477 20.0958 114.033 20.6463 113.439 21.8664L115.145 22.5082C115.512 21.8664 116.187 21.6582 116.901 21.6582C117.898 21.6582 118.909 22.196 118.925 23.1454V23.2668C118.577 23.0864 117.832 22.8193 116.916 22.8193C115.079 22.8193 113.207 23.7271 113.207 25.4213C113.207 26.971 114.712 27.969 116.403 27.969C117.697 27.969 118.411 27.4451 118.859 26.8357H118.925V27.7296H120.781V23.2934C120.781 21.243 119.075 20.0958 116.866 20.0958ZM116.634 26.4332C116.005 26.4332 115.129 26.1534 115.129 25.4537C115.129 24.5586 116.222 24.2151 117.167 24.2151C118.014 24.2151 118.411 24.3828 118.925 24.6037C118.774 25.6746 117.747 26.4332 116.634 26.4332ZM127.545 20.3491L125.336 25.3623H125.27L122.986 20.3491H120.913L124.345 27.3549L122.387 31.2534H124.395L129.684 20.3491H127.545ZM110.218 27.7481H112.145V16.1835H110.218V27.7481Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4686_96277",
    x1: 22.4685,
    y1: 28.9426,
    x2: 7.0321,
    y2: 11.7453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4686_96277",
    x1: 34.8739,
    y1: 18.4966,
    x2: 9.934,
    y2: 18.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4686_96277",
    x1: 25.5908,
    y1: 16.373,
    x2: 4.65774,
    y2: -6.94797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4686_96277",
    x1: 7.52278,
    y1: 36.837,
    x2: 16.8703,
    y2: 26.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.333a07ded2060f94df9e1b42dae633ba.svg";
export { ForwardRef as ReactComponent };